import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-stacking-looks-button.svg'


const _hoisted_1 = {
  key: 0,
  class: "all-panel-container"
}
const _hoisted_2 = { class: "all-panel-drawer-content" }
const _hoisted_3 = { class: "all-panel-drawer-header-wrapper" }
const _hoisted_4 = { class: "all-panel-drawer-header" }
const _hoisted_5 = { class: "all-panel-drawer-header-title font-16 PingFangSC-Medium" }
const _hoisted_6 = { class: "select-by-photos font-14 PingFangSC-Regular" }
const _hoisted_7 = { class: "all-panel-drawer-cards" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "card-btn-container" }
const _hoisted_10 = { class: "card-btn" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "card-title font-14 PingFangSC-Medium" }

import useSelect from '@/hooks/use-select'
import {
  computed,
  onUnmounted,
  ref,
  watch
} from 'vue'
import {
  FormattedStacking,
  namedImages,
  useCameraFrameStore,
  useConfAndQueryStore,
  useLayoutStore,
  useStackingStore
} from '@/store'
import { storeToRefs } from 'pinia'
import { delay, throttle } from '@/utils'
import useDrawer, { OffsetUpdater } from '@/hooks/use-drawer'
import { ClickAction } from '@/data/report'
import { PosterName } from '@/data/images'


export default /*@__PURE__*/_defineComponent({
  __name: 'StackingsPanel',
  props: {
  visible: Boolean
},
  emits: ['hide'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props

const { report } = useConfAndQueryStore()
const { selectStacking } = useSelect()
const stackingStore = useStackingStore()
const { selectedStackingSet, selectedStackings } = storeToRefs(stackingStore)
const cameraFrameStore = useCameraFrameStore()
const { resumeCamera, pauseCamera } = cameraFrameStore
const layoutStore = useLayoutStore()
const { updatePdpExpandingProgress } = layoutStore
const { target, offset, isScrollable, expand, collapse } = useDrawer(0)

const scrollview = ref()
const computedOffsetY = computed(() => {
  return `${offset.value.y}px`
})

const isScrollMaskShown = ref(false)
const onScrollviewScroll = () => {
  if (scrollview.value?.scrollTop >= 30) {
    isScrollMaskShown.value = true
  } else {
    isScrollMaskShown.value = false
  }
}

const onCardClick = throttle(async (stacking: FormattedStacking) => {
  report(ClickAction.STACKING_CARD, stacking.titleString)

  selectStacking(stacking)
  await delay(200)
  emit('hide')
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      expand(0.6)
    } else {
      collapse(0.6)
    }
  }
)

watch(offset, ov => {
  // if (ov._updater === OffsetUpdater.NONE || ov._updater === OffsetUpdater.CSS) {
  //   console.log('[[ Drawer ] Stackings Panel Offset ]', ov)
  // }
  updatePdpExpandingProgress({
    target: 'stackings',
    y: ov.y,
    progress: ov.progress / 100,
    transiting: ov._updater !== OffsetUpdater.NONE,
    transitingByCSS: ov._updater === OffsetUpdater.CSS
  })
  if (ov._real_progress === 0 && ov._updater === OffsetUpdater.NONE) {
    resumeCamera()
  } else if (ov._updater !== OffsetUpdater.NONE) {
    pauseCamera()
  }
  if (ov.progress === 0 && ov._updater === OffsetUpdater.NONE) {
    scrollview.value?.scrollTo({
      top: 0
    })
    if (props.visible) {
      emit('hide', true)
    }
  }
})

onUnmounted(() => {
  // console.log('[[ Layout ] Stackings Panel Unmounted ]')
  emit('hide', true)
})

return (_ctx: any,_cache: any) => {
  return (_unref(selectedStackings).length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["all-panel-mask", { visible: __props.visible }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('hide')))
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["all-panel-drawer", [_unref(layoutStore).drawerStateClassName]]),
          ref_key: "target",
          ref: target,
          style: _normalizeStyle({
        '--scrollview-overflow': _unref(isScrollable) ? 'hidden auto' : 'hidden',
        '--computed-offset-y': computedOffsetY.value
      })
        }, [
          _createElementVNode("div", {
            class: "all-panel-drawer-handle",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('hide')))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["all-panel-drawer-handle-mask", {
            mask: isScrollMaskShown.value
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["all-panel-drawer-handle-bar", {
            bigger: _unref(offset).progress >= 18
          }])
            }, null, 2)
          ]),
          _createElementVNode("div", {
            ref_key: "scrollview",
            ref: scrollview,
            class: "all-panel-drawer-scrollview",
            "data-is-touchable": "both",
            onScroll: onScrollviewScroll
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(selectedStackingSet)?.subtitle), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                      class: "photos-left-icon",
                      src: _imports_0
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(selectedStackings).length) + "个造型 ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedStackings), (stacking) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stacking.guid,
                    class: "all-panel-drawer-card",
                    "data-is-touchable": "clickable",
                    onClick: ($event: any) => (_unref(onCardClick)(stacking))
                  }, [
                    _createElementVNode("div", {
                      class: "card-poster",
                      style: _normalizeStyle(`background-image: url(${_unref(namedImages)[
          `${stacking.code}_cover` as PosterName
        ]})`)
                    }, null, 4),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: _unref(namedImages).icon_try_on_black
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(stacking.titleString), 1)
                    ])
                  ], 8, _hoisted_8))
                }), 128))
              ])
            ])
          ], 544)
        ], 6)
      ]))
    : _createCommentVNode("", true)
}
}

})